import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class EdgeDeviceKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { ids, siteId } = criteria ?? {};
        return this.get('/devices', {
            ...(paginationRequest && {
                params: { continuationToken, pageSize, sort, ids: ids?.join(','), siteId },
            }),
            ...requestConfig,
        });
    }
    claimDevice(payload, requestConfig) {
        return this.post('/devices', payload, requestConfig);
    }
    update(payload, requestConfig) {
        const { id } = payload;
        return this.patch(`/devices/${id}`, payload, requestConfig);
    }
}
//# sourceMappingURL=edge-device.js.map